"use client";
import { jsxs as p, jsx as n } from "react/jsx-runtime";
import u from "clsx";
import { memo as _ } from "react";
import '../../assets/CheckBox.css';const h = "_label_2ne40_1", x = "_input_2ne40_12", d = "_checkmark_2ne40_19", k = "_text_2ne40_34", e = {
  label: h,
  input: x,
  checkmark: d,
  text: k
}, b = _(
  ({ text: l, className: f, onClick: t, loading: o, disabled: c, ...m }) => {
    const i = (a) => {
      var r;
      if (o || c) {
        a.preventDefault();
        return;
      }
      const s = a.currentTarget.getAttribute("data-event");
      s && ((r = window == null ? void 0 : window.dataLayer) == null || r.push({
        event: s
      })), t == null || t(a);
    };
    return /* @__PURE__ */ p("label", { className: e.label, onClick: i, children: [
      /* @__PURE__ */ n(
        "input",
        {
          className: e.input,
          type: "checkbox",
          disabled: c,
          readOnly: !0,
          ...m
        }
      ),
      /* @__PURE__ */ n(
        "div",
        {
          className: u("material-icons", e.checkmark),
          "data-icon": "done"
        }
      ),
      /* @__PURE__ */ n("span", { className: e.text, children: l })
    ] });
  }
);
b.displayName = "CheckBox";
export {
  b as CheckBox
};
